module.exports = __webpack_public_path__ + "media/images/photo/top/album/album3-450599a6f058d8cf0b21472065014cf0.jpg";